export function bondListConfig(getMoney, selectPersonClick, selectDeptClick) {
  return {
    menuType: "button",
    addBtn: false,
    menuWidth: 120,
    menuAlign: "center",
    card: true,
    menu: false,
    delBtn: false,
    editBtn: false,
    align: "center",
    searchMenuSpan: 8,
    columnBtn: false,
    searchBtn: true,
    searchShow: false,
    // index: true,
    // indexLabel: "序号",
    refreshBtn: true,
    border:true,
    column: [{
        label: "项目名称",
        placeholder: "请输入项目名称",
        search: true,
        searchslot: true,
        prop: "projectName",
        width: "200",
        // overHidden: true
      },
      {
        label: "客户名称",
        placeholder: "请输入客户名称",
        search: true,
        prop: "sellerCustName",
        width: "200",
        overHidden: true
      },
      // {
      //   label: '保理商',
      //   prop: "formAccountingEntity",
      //   type: "select",
      //   dicUrl: '/api/blade-system/dict-biz/dictionary?code=rzzl_accounting_entity',
      //   dataType: 'number',
      //   props: {
      //     label: "dictValue",
      //     value: "dictKey"
      //   },
      //   width: '280',

      // },
      {
        label: "保理合同",
        prop: "contractName",
        width: "180",
        slot: true,
        overHidden: true
      },
      {
        label: "批次",
        prop: "batchStr",
        width: "100",
        overHidden: true
      },
      // {
      //   label: '保证金类型',
      //   prop: "dictDepositType",
      //   type: "select",
      //   search: true,
      //   dicUrl: '/api/blade-system/dict-biz/dictionary?code=dict_deposit_type',
      //   dataType: 'number',
      //   props: {
      //     label: "dictValue",
      //     value: "dictKey"
      //   },
      //   width: '280',
      //   searchLabelWidth: 100

      // },
      {
        label: "保证金到期日",
        prop: "expirationDate",
        width: "120",
        overHidden: true
      },
      {
        label: "收取方式",
        prop: "outlayWayStr",
        width: "100",
        overHidden: true
      },
      {
        label: "到期处理方式",
        prop: "expirationTreatmentStr",
        width: "100",
        overHidden: true
      },
      {
        label: "应收金额（元）",
        prop: "receivableAmount",
        width: "150",
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        }
      }, {
        label: "已收金额（元）",
        prop: "receivedAmount",
        width: "150",
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        }
      }, {
        label: "已抵扣金额（元）",
        prop: "deductedAmount",
        width: "150",
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        }
      }, {
        label: "已退回金额（元）",
        prop: "refundedAmount",
        width: "150",
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        }
      }, {
        label: "保证金余额（元）",
        prop: "surplusAmount",
        width: "150",
        formatter: (row, value, label, column) => {
          return `${getMoney(value)}元`;
        }
      },
    ]
  }
}

export function projectConfig() {
  return [{
      label: '项目名称',
      prop: 'projectName',
      span: '12'
    },
    {
      label: '合同编号',
      prop: 'contractName',
      span: '12',

    },
    {
      label: '客户名称',
      prop: 'sellerCustName',
      span: '12'
    },
    // {
    //   label: '业务类型',
    //   prop: '',
    //   span: '12'
    // },
    {
      label: '批次',
      prop: 'batchStr',
      span: '12'
    },
    {
      label: '保理商',
      prop: 'formAccountingEntityStr',
      span: '12'
    },{
      label: '业务主办',
      prop: 'managerUserName',
      span: '12'
    },{
      label: '业务协办',
      prop: 'assistUserName',
      span: '12'
    },
  ]
}

export function bondConfig(getMoney) {
  return [{
      label: '收取方式',
      prop: 'outlayWayStr',
      span: '12'
    },
    {
      label: '到期处理方式',
      prop: 'expirationTreatmentStr',
      span: '12'
    },
    {
      label: '保证金金额',
      prop: 'receivableAmount',
      span: '12',
      formatter: (row, value, label, column) => {
        return `${getMoney(value)}元`;
      }
    },
    {
      label: '已收保证金',
      prop: 'receivedAmount',
      span: '12',
      formatter: (row, value, label, column) => {
        return `${getMoney(value)}元`;
      }
    },
    
    {
      label: '剩余保证金',
      prop: 'surplusAmount',
      span: '12',
      formatter: (row, value, label, column) => {
        return `${getMoney(value)}元`;
      }
    },

  ]
}

export function deductionConfig(getMoney) {
  return [{
      label: '抵扣金额',
      prop: 'deductedAmount',
      span: '12',
      formatter: (row, value, label, column) => {

        return `${getMoney(value)}元`;
      }
    },

    {
      label: '申请时间',
      prop: 'deductionTime',
      span: '12',

    },

  ]
}


export function backConfig(getMoney) {
  return {
    menuWidth: 200,
    detailBtn: false,
    editBtn: false,
    delBtn: false,
    addBtn:false,
    index: false,
    indexLabel: "序号",
    align: 'center',
    readonly: true,

    column: [{
        label: "放款次号",
        prop: "paymentBatch",
        formatter: (row, value, label, column) => {

          return `第${value}笔`;
        }
      },
      {
        label: "款项标题",
        prop: "investName",
        width: 200
      },

      {
        label: "放款金额",
        prop: "investShouldMoney",
        placeholder: "请输入金额",
        formatter: (row, value, label, column) => {

          return `${getMoney(value)}元`;
        }
      },
      {
        label: "核销人员",
        prop: "writeoffUserName",
      },
      {
        label: "核销日期",
        prop: "writeoffTime",


      },

    ],
  }
}
